export default __webpack_public_path__ + "static/media/arrow-up-white.b5e7eecb.svg";